module.exports = __webpack_public_path__ + "static/media/backdrop.41d061c2.svg";